import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { Button } from './button.js';

const helpers = createMultiStyleConfigHelpers([
  "radioSelectionGroup",
  "checkboxSelectionGroup",
  "radioSelectionItem",
  "checkboxSelectionItem"
]);
const SelectionGroup = helpers.defineMultiStyleConfig({
  baseStyle: {
    radioSelectionGroup: {
      bgColor: Button.variants?.secondary.backgroundColor,
      display: "flex",
      width: "fit-content",
      gap: "sm",
      _dark: {
        bgColor: Button.variants?.secondary._dark.backgroundColor
      }
    },
    checkboxSelectionGroup: {
      display: "flex",
      gap: "sm"
    },
    radioSelectionItem: {
      ...Button.baseStyle,
      ...Button.variants?.tertiary,
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      _dark: {
        color: "white",
        bgColor: "grayscale.700"
      },
      _hover: {
        bgColor: "grayscale.100",
        _dark: {
          bgColor: "grayscale.600"
        }
      },
      _checked: {
        bgColor: "grayscale.200",
        _dark: {
          bgColor: "grayscale.500"
        }
      },
      _disabled: {
        opacity: 0.5
      }
    },
    checkboxSelectionItem: {
      ...Button.baseStyle,
      ...Button.variants?.secondary,
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      _dark: {
        color: "white",
        bgColor: "grayscale.700"
      },
      _hover: {
        bgColor: "grayscale.100",
        _dark: {
          bgColor: "grayscale.600"
        }
      },
      _checked: {
        bgColor: "grayscale.200",
        _dark: {
          bgColor: "grayscale.500"
        }
      },
      _disabled: {
        opacity: 0.5
      }
    }
  },
  sizes: {
    xs: {
      radioSelectionGroup: {
        borderRadius: Button.sizes?.xs.borderRadius
      },
      radioSelectionItem: {
        ...Button.sizes?.xs
      },
      checkboxSelectionItem: {
        ...Button.sizes?.xs
      }
    },
    sm: {
      radioSelectionGroup: {
        borderRadius: Button.sizes?.sm.borderRadius
      },
      radioSelectionItem: {
        ...Button.sizes?.sm
      },
      checkboxSelectionItem: {
        ...Button.sizes?.sm
      }
    },
    md: {
      radioSelectionGroup: {
        borderRadius: Button.sizes?.md.borderRadius
      },
      radioSelectionItem: {
        ...Button.sizes?.md
      },
      checkboxSelectionItem: {
        ...Button.sizes?.md
      }
    },
    lg: {
      radioSelectionGroup: {
        borderRadius: Button.sizes?.lg.borderRadius
      },
      radioSelectionItem: {
        ...Button.sizes?.lg
      },
      checkboxSelectionItem: {
        ...Button.sizes?.lg
      }
    }
  }
});

export { SelectionGroup };
